import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import ActionMenu from "../../../../../components/app/ActionMenu";
import CptCodeCatalogDrawer from "../../../../../components/app/admin/Library/catalog/CptCodeCatalogDrawer";
import CustomDataGridV2 from "../../../../../components/CustomDataGridV2";
import ToggleSwitch from "../../../../../components/ToggleSwitch";
import { cptCodeCatalogInitialValuesType } from "../../../../../constants/initial-schemas";
import { CptCodeCatalog } from "../../../../../dummy-data/cpt-code-catalog";
import useDisclosure from "../../../../../hooks/use-disclosure";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
import { useArchiveCatalogCode } from "../../../../../queries/catalog/use-archive-catalog-code";
import useGetCataLogCode from "../../../../../queries/catalog/use-get-catalog-code";
import { useStatusUpdateCatalogCode } from "../../../../../queries/catalog/use-status-update-catalog-code";
import {
  DEFAULT_PAGE_SIZE,
  applyDefaultColumnSettings,
  DGT_Pagination,
  filterActionCol,
  getSuccessSnackbar,
  isAdmin,
} from "../../../../../utils/utils";
// import { GlobalTableHeightWrapper } from "../../../../../components/GlobalTableHeightWrapper";
import PageLayout from "../../../../../components/PageLayout";
import {
  CATALOG_ACTION,
  CATALOG_ACTIVE_ACTIONS,
  CATALOG_ARCHIVED_ACTIONS,
} from "./catalog-constant";
import { CatalogOutletContext } from "./catalog-types";
import { useCatalogCodeAccess } from "./hooks/use-catalog-code-access";

const CatalogCPTCodeCatalog = () => {
  const { search: searchKey, isArchieved: archived } =
    useOutletContext<CatalogOutletContext>();
  const hasUpdate = useCatalogCodeAccess("CPT");

  const [pagination, setPagination] = useState<DGT_Pagination>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const {
    data,
    refetch,
    isLoading: isTableLoading,
    isFetching,
  } = useGetCataLogCode({
    gridSorting,
    pagination,
    searchKey,
    type: "CPT",
    active: undefined,
    archive: archived,
  });

  const { mutateAsync: updateStatus } = useStatusUpdateCatalogCode();
  const { mutateAsync: deleteCptCode } = useArchiveCatalogCode();
  const showSnackbar = useSnackbar();

  const cptEditModalDisclosure = useDisclosure(false);
  const [editCptCodeValues, setEditCptCodeValues] =
    useState<cptCodeCatalogInitialValuesType>();
  const [uuid, setUuid] = useState<string>();

  // const {
  //   opened: openedDeleteModal,
  //   open: openDeleteModal,
  //   close: closeDeleteModal,
  //   deleteId,
  // } = useDeleteDisClosure(false);

  const COLUMNS = applyDefaultColumnSettings<CptCodeCatalog>([
    {
      field: "code",
      headerName: "CPT Code",
      flex: 0.5,
      minWidth: 180,
      sortable: false,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      minWidth: 500,
      sortable: false,
    },
    {
      field: "active",
      headerName: "Status",
      sortable: false,
      width: 150,
      renderCell: ({ row, value }) => (
        <ToggleSwitch
          id={row.uuid.toString()}
          checked={value}
          onConfirm={(status, id) =>
            updateStatus({ medicalCodeId: id as string, status }).then(
              (res) => {
                refetch();
                return res;
              }
            )
          }
        />
      ),
    },
    {
      field: "Action",
      width: 90,
      hideSortIcons: true,
      renderCell: ({ row }) => {
        return (
          <ActionMenu
            options={
              row?.archive ? CATALOG_ARCHIVED_ACTIONS : CATALOG_ACTIVE_ACTIONS
            }
            onActionClick={(v) => {
              if (v === CATALOG_ACTION.EDIT) {
                const values = {
                  cpt_code: row?.code,
                  description: row?.description,
                };
                setUuid(row.uuid?.toString());

                setEditCptCodeValues(values);
                cptEditModalDisclosure.open();
              } else {
                deleteCptCode({
                  medicalCodeId: row?.uuid?.toString() as string,
                  archive: v === CATALOG_ACTION.ARCHIVE,
                }).then((res) => {
                  refetch();
                  showSnackbar(getSuccessSnackbar(res));
                  return res;
                });
              }
            }}
          />
        );
      },
    },
  ]);

  return (
    <PageLayout>
      {/* <DeleteModal
        w="380px"
        open={openedDeleteModal}
        onClose={closeDeleteModal}
        id={deleteId}
        onConfirmation={(id) =>
          deleteCptCode({ medicalCodeId: id as string }).then((res) => {
            refetch();
            return res;
          })
        }
        content={"You want to delete this CPT Code"}
      /> */}
      <CptCodeCatalogDrawer
        initialValues={editCptCodeValues}
        dialogTitle="Edit CPT Code"
        disclosureHost={cptEditModalDisclosure}
        uuid={uuid}
      />
      <CustomDataGridV2
        loading={isTableLoading || isFetching}
        searchString={searchKey}
        rows={data?.data?.content ?? []}
        getRowId={(row) => row?.uuid}
        columns={filterActionCol(COLUMNS, !isAdmin() ? !hasUpdate : false)}
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        onSortModelChange={setGridSorting}
        rowCount={data?.data?.page?.totalElements ?? 10}
        disableRowSelectionOnClick
      />
    </PageLayout>
  );
};

export default CatalogCPTCodeCatalog;
